module.exports = __webpack_public_path__ + "static/minute_of_islands-f5534100f5e7867f29e36e69a7620998.png";